<template>
  <div style="min-width:280px; max-width:400px;" class="flex-grow-1">
    <v-form ref="form">
      <v-card elevation="10">
        <v-overlay absolute :value="isProcessing" opacity=".6">
          <v-row justify="center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
          <v-row justify="center">
            Working on it...
          </v-row>
        </v-overlay>
        <v-toolbar
          style="border-top-left-radius: 4px; border-top-right-radius: 4px;"
          color="info white--text"
          flat
          short>
          <v-toolbar-title>
            <v-icon color="white">mdi-lock</v-icon>
            Choose Verification Type
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text style="min-height:182px">
          <div class="text-center">
            We need to send you a one-time-use code so you can log in. How would you like to be contacted?
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="primary" :to="{name: 'LoginEmailAddress'}" :disabled="isProcessing" text>
            <v-icon>mdi-restart</v-icon>
            Start Over
          </v-btn>
          <div class="d-flex justify-end" style="width: 100%">
            <v-btn color="primary" class="mr-2" :disabled="isProcessing" @click="submitVerifyType('voice')">
              <v-icon class="mr-2">mdi-phone-in-talk</v-icon>
              Voice
            </v-btn>
            <v-btn color="primary" :disabled="isProcessing" autofocus @click="submitVerifyType('sms')">
              <v-icon class="mr-2">mdi-message-text</v-icon>
              Text
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import Logger from '@/services/Logger'

export default {
  name: 'LoginContactType',

  props: {
    emailAddress: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isProcessing: false
  }),
  mounted () {
    if (!this.emailAddress) {
      this.$router.push({ name: 'LoginEmailAddress' })
    }
  },
  methods: {
    submitVerifyType (type) {
      this.isProcessing = true
      this.$emit('contactTypeSubmitted', { type, emailAddress: this.emailAddress })
      this.$store
        .dispatch('auth/beginLogin', {
          emailAddress: this.emailAddress,
          type: type
        })
        .then(result => {
          if (result.success === true) {
            this.$emit('logInSubmitted', type)
            this.$router.push({
              name: 'LoginVerify',
              params: {
                emailAddress: this.emailAddress,
                type: type,
                phoneNumberMasked: result.cellphone
              }
            }).catch(() => {})
          } else {
            this.startOver(true, result.message)
          }
        })
        .catch(error => {
          Logger.error(error)
          this.startOver(true, error.message)
        })
        .finally(() => {
          this.isProcessing = false
        })
    },
    startOver (isLoginError = false, errorMessage = null) {
      this.$router.push({
        name: 'LoginEmailAddress',
        params: {
          isLoginError: isLoginError,
          errorMessage: errorMessage,
          emailAddress: this.emailAddress
        }
      })
    }
  }
}
</script>
